import { useState } from 'react';
import AgentsSection from '../components/home/AgentsSection';
import CTASection from '../components/home/CTASection';
import EquipoolAdvantageSection from '../components/home/EquipoolAdvantageSection';
import FAQSection from '../components/home/FAQSection';
import HeroSection from '../components/home/HeroSection';
import HomeSectionContainer from '../components/home/HomeSectionContainer';
import { useModalContext } from '../contexts/ModalContext';
import { useSignupStore } from '../stores/signupStore';
import { UserFormTypeRole } from '../utils/user';

export default function HomePage() {
  const { openSignupModal } = useModalContext();
  const signupStore = useSignupStore();

  const [FAQView, setFAQView] = useState<'borrower' | 'investor' | 'overall'>('borrower');

  // Handler functions for the main CTA buttons
  const handleBorrowerButtonClick = () => {
    signupStore.setRole(UserFormTypeRole.BORROWER);
    openSignupModal();
  };

  const handleInvestorButtonClick = () => {
    signupStore.setRole(UserFormTypeRole.INVESTOR);
    openSignupModal();
  };

  return (
    <div className="min-h-screen bg-white mt-[135px]">
      <HeroSection onBorrowerClick={handleBorrowerButtonClick} onInvestorClick={handleInvestorButtonClick} />

      <HomeSectionContainer
        headerLabel="Authorized Agents"
        title="If you don’t have a Qualification Code yet, start here."
      >
        <AgentsSection />
      </HomeSectionContainer>

      <HomeSectionContainer
        headerLabel="Equipool Advantage"
        title="A New Era Of Borrowing And Investing"
        description="No middlemen. No hidden fees. Just fair capital for homeowners and efficient, real estate–backed opportunities for investors — borrowing and investing, reimagined."
      >
        <EquipoolAdvantageSection />
      </HomeSectionContainer>

      <HomeSectionContainer headerLabel="FAQ" title="Common Questions">
        <FAQSection activeView={FAQView} onViewChange={setFAQView} />
      </HomeSectionContainer>

      <div className="mt-[180px]">
        <CTASection onBorrowerClick={handleBorrowerButtonClick} onInvestorClick={handleInvestorButtonClick} />
      </div>

      <div className="mt-[60px]" />
    </div>
  );
}
